<template lang="pug">
  
  .full-width-wrapper
    div
      //-childコンポーネントのrouter-view
      #child-area
        router-view(ref="myPageChild")
      #headline 
        .m-1 <b>{{$parent.rockyName}}</b> 
        .ml-1 のトポ
    div.d-flex.flex-wrap.mt-2
      .col-6.col-md-4(v-for="rock in this.rockList")
        #rock-img-list-box
          #rock-img-list-box-innner(@click="callRouteList(rock.id,rock.name)")
            .rockCard.mt-1
              .img-box
                img(v-bind:src="createImgPath(rock.imgList[0].path)" v-bind:alt="rock.name")
                .rocky-ban(v-if="rock.banFlg==1") 登攀禁止
                .vrModel(v-if="rock.isVrModelExist == true") 3D 
                .rock-checkin(v-if="rock.checkinCount > 0") 本日<span>{{rock.checkinCount}}人</span>がチェックイン
                .level
                  div {{rock.blLevel}}
                  div {{rock.rcLevel}}
              .rock-name {{rock.name}}
</template>

<script>
export default {
// データオブジェクト
  data() {
    return {
      //親コンポーネントの値を利用する
      rockList: this.$parent.rockList,
      rockyId:this.$parent.rockyId,
      isLogin:false,
      //rocky-InfoAPIの戻り値を保持
      rockyMasterData:null,
    }
  },
  created(){
    //直接アクセス等で親画面のデータが空の場合、親画面に遷移する
    if(this.$parent.rockyMasterData == null){
      this.$router.push({ 
        name: 'rockyInfo_:rockyId', 
        params: { 
          rockyId: this.$route.params.rockyId, 
        }
      })
    }

  },
  mounted(){
    //岩アイコンを表示する(Mapコンポーネント内のメソッド実行)
    this.$parent.$refs.map.showRockMarker(true)
  },
  // メソッド
  methods: {
    //---------------------------------------
    // 岩画像選択時の処理(ルート一覧を表示する)
    //---------------------------------------
    async callRouteList(rockId,rockName){

      //ルート画面を表示する
      this.$router.push({ 
        name: 'rockyInfo_:rockyId_:rockId', 
        params: { 
          rockyId: this.$route.params.rockyId, 
          rockId:rockId,
          rockName:rockName,
          rockyMasterData:this.$parent.rockyMasterData,
        }
      })

    },
    //---------------
    // 画像パスを生成
    //---------------
    createImgPath(path){
      return this.getRockThumbPath(path,this.$route.params.rockyId,'360')
    }
  }
}
</script>

<style lang="stylus" scoped>

#headline
  height 40px
  font-size 1.1rem
  background #004170
  color #FFF
  padding-left 0.7rem
  display flex
  align-items center

//岩画像List
.col-6,.col-md-4
  padding 5px 5px
#rock-img-list-box
  width 100%
  #rock-img-list-box-innner
    cursor pointer
    display flex
    align-items center
    .rockCard
      width 100%
      box-shadow 2px 2px 6px 0 rgba(0,0,0,0.2)
      .img-box
        position relative
        img
          width 100%
          height 17vh
          object-fit cover
        .rocky-ban
          position absolute
          left 0
          top 0
          color #d2202f
          font-size 1rem
          font-weight 600
          background rgba(222,225,227,0.6)
          padding 2px 0.8rem
        .vrModel
          position absolute
          right 0
          top 0
          color #fff
          font-size 0.8rem
          font-weight 600
          background rgba(0,0,0,0.6)
          padding 2px 1rem
        .rock-checkin
          position absolute
          right 0
          bottom 40px
          height 15px
          font-size 0.7rem
          padding 0 3px
          background rgba(120,103,19,0.8)
          color #fff
        .level
          position absolute
          right 0
          bottom 0
          height 35px
          font-size 0.7rem
          color #fff
          div
            padding 0 3px
            color rgba(255,255,255,0.7)
            background rgba(0,0,0,0.4)
      .rock-name
        width 100%
        height 35px
        font-size 0.8rem
        font-weight 600
        padding 0.5rem
        display flex
        align-items center
        overflow hidden
        text-overflow ellipsis

// 大デバイス（デスクトップ, 992px 以上）
@media (min-width 992px)
  #rock-img-list-box
    #rock-img-list-box-innner
      .rockCard
        .img-box
          img
            height 27vh

</style>